"use client";

import { CountryInfo, HighlightItem } from "@/store/types/countryTypes";
import Image from "next/image";
import React from "react";
import { Award, Briefcase, Plane, FlaskConical } from "lucide-react";

import MarkdownText from "../common/MarkdownText";
import { getCountryContextLinks } from "@/utils/contextualLinks";

const renderIcon = (item: HighlightItem) => {
  if (item.iconImage) {
    return (
      <div className="relative w-10 h-10 shrink-0">
        <Image src={item.iconImage} alt={item.title} fill className="object-contain" />
      </div>
    );
  }

  return <Award className="w-8 h-8 text-[#021A38] shrink-0" />;
};

const CountryHighlights: React.FC<{ country: CountryInfo }> = ({ country }) => {
  const highlights = country?.highlights || [];

  if (highlights.length === 0 && !country?.description) {
    return null;
  }

  return (
    <div className="w-full space-y-5 my-8">
      {/* 2x2 HIGHLIGHTS GRID */}
      {highlights.length > 0 && (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {highlights.map((item, index) => (
            <div
              key={index}
              className="bg-white rounded-[18px] border border-[#E0D8FF] p-5 sm:p-6 flex items-start gap-4 shadow-sm hover:shadow-md transition-shadow"
            >
              <div className="p-2.5 rounded-xl bg-[#F4F0FF] border border-[#E6DDFF]">
                {renderIcon(item)}
              </div>
              <div>
                <h3 className="text-base sm:text-lg font-bold text-[#1C2233] ff_poppins leading-snug">
                  {item.title}
                </h3>
                <p className="mt-1 text-xs sm:text-sm text-[#525B73] ff_poppins leading-relaxed">
                  {item.subtitle}
                </p>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* OVERVIEW TEXT BOX */}
      {country?.description && (
        <div className="bg-white rounded-[18px] border border-[#E0D8FF] p-6 sm:p-7 shadow-sm">
          <MarkdownText
            content={country.description}
            keywords={getCountryContextLinks(country?.countryName)}
            className="text-xs sm:text-sm text-[#333E5C] leading-relaxed font-normal ff_poppins"
          />
        </div>
      )}
    </div>
  );
};

export default CountryHighlights;

